/**
 * @author Madhu.Sudhan
 * @Date: 2023-004-25 13:07:40
 * @Last Modified by: madhusudhan
 * @Last Modified time: 2023-04-26 12:16:58
 */

export const FETCH_ONLINE_TRANSACTION_LIMIT = '/YesBankTransactionLimits/FETCH_ONLINE_TRANSACTION_LIMIT';
export const UPDATE_ONLINE_TRANSACTION_LIMIT = '/YesBankTransactionLimits/UPDATE_ONLINE_TRANSACTION_LIMIT';
export const DEFAULT_ACTION = '/DEFAULT_ACTION';

const YBL_MODIFY_LIMITS_CONSTANTS = Object.freeze({
  YBL_UPDATE_LIMITS_OTP_SUCCESS: '/YesBankTransactionLimits/YBL_UPDATE_LIMITS_OTP_SUCCESS',
  COMPLETE_OTP_VERIFICATION: 'Please Verify the OTP to update the Limits',
  CONTACT_CUSTOMER_CARE: 'Not your number ? Contact customer service',
  YBL_SET_CHANNEL_FLAG_SUCCESS: '/YesBankTransactionLimits/YBL_SET_CHANNEL_FLAG_SUCCESS',
});

export { YBL_MODIFY_LIMITS_CONSTANTS };



// WEBPACK FOOTER //
// client/containers/YesBankTransactionLimits/constants.js